import { Calculator, ExternalLink, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0,
  }).format(Number(n ?? 0));
}

/**
 * SimulateBatchResult — shown after simular_lote_nominas runs.
 * Displays totals + procesados/errores + deeplink to the period.
 */
export default function SimulateBatchResult({ result }) {
  if (!result) return null;
  const r = result.resumen ?? {};
  const errores = result.errores ?? 0;

  return (
    <div className="rounded-xl border border-info/30 bg-info/10 p-3 my-1 max-w-sm space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Calculator className="w-4 h-4 text-info shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground">
              Simulación · {result.periodo}
            </p>
            <p className="text-[10px] text-muted-foreground">
              {result.procesados ?? 0} de {result.total_empleados ?? 0} empleados
              {result.ajustes_aplicados > 0 && ` · ${result.ajustes_aplicados} ajustes`}
              {errores > 0 && (
                <span className="inline-flex items-center gap-0.5 text-destructive ml-1">
                  · <AlertTriangle className="w-2.5 h-2.5" /> {errores}
                </span>
              )}
            </p>
          </div>
        </div>
        <Link to={`/nominas?periodo=${result.periodo}`}>
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-info/30 text-info hover:bg-info/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-3 gap-2 text-[10px] border-t border-info/30 pt-2">
        <div>
          <p className="text-muted-foreground">Bruto</p>
          <p className="font-semibold tabular-nums">{formatEur(r.totalBruto)}</p>
        </div>
        <div>
          <p className="text-muted-foreground">IRPF</p>
          <p className="font-semibold tabular-nums">{formatEur(r.totalIRPF)}</p>
        </div>
        <div>
          <p className="text-muted-foreground">Neto</p>
          <p className="font-semibold tabular-nums text-info">{formatEur(r.totalNeto)}</p>
        </div>
      </div>
    </div>
  );
}
